// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'core-js/fn/promise'

async function initVueApps() {
	import(/* webpackChunkName: "meccalte" */ '@/assets/scripts/meccalte.js')

	const [
		{ default: Vue },
		{ default: VueLazyload },
		{ default: App }
	] = await Promise.all([
		import(/* webpackChunkName: "vue" */ 'vue'),
		import(/* webpackChunkName: "vue-lazyload" */ 'vue-lazyload'),
		import(/* webpackChunkName: "main" */ './App'),
		import(/* webpackChunkName: "style" */ '@/assets/styles/main.css')
	])

	Vue.use(VueLazyload, {
		listenEvents: ['scroll', 'transitionstart', 'animationstart'],
		attempts: 1,
	})

	Vue.config.productionTip = false

	new Vue({
		el: '#app',
		render: h => h(App)
	})
}

window.addEventListener('DOMContentLoaded', initVueApps);


// WEBPACK FOOTER //
// ./app/main.js